window.klarnachrichten.trackMatomoEvent = (eventName, eventData = "") => {
  if (!window._paq) {
    return;
  }

  window._paq.push(["trackEvent", eventName, eventData]);

  // For Dev:
  // console.log(`Matomo event tracked | "${eventName}" - "${eventData}"`);
};
